import { useParams, Navigate } from "react-router-dom";
import { mapIcons, toSlug } from "utils";
import Onboarding from "pages/Onboarding";
import SecurityVendorDataServices from "pages/Security_Vendor_Data_Services";
import onboardingData from "data/onboardingData.json";
import securityVendorData from "data/vendorServicesData.json";
import { useScrollRestoration } from "hooks";

const mappedOnboardingData = onboardingData.map(mapIcons);
const mappedSecurityVendorData = securityVendorData.map(mapIcons);

const items = [...mappedOnboardingData, ...mappedSecurityVendorData];

export default function ServicesRouter() {
  const { slug } = useParams();
  const activeItem =
    items.find((item) => toSlug(item.name) === slug) || items[0];
  const isOnboarding = mappedOnboardingData.includes(activeItem);

  const dataSet = isOnboarding
    ? mappedOnboardingData
    : mappedSecurityVendorData;
  const Component = isOnboarding ? Onboarding : SecurityVendorDataServices;

  useScrollRestoration(isOnboarding ? "onboarding" : "securityVendor");

  if (!slug) {
    return <Navigate to={`/services/${toSlug(activeItem.name)}`} replace />;
  }

  return <Component data={dataSet} activeSlug={toSlug(activeItem.name)} />;
}
